import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  HostBinding,
  Host,
  OnInit,
  OnChanges,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

import { NbAccordionComponent } from './accordion.component';
import { convertToBoolProperty } from '../helpers';

@Component({
  selector: 'nb-accordion-item',
  styleUrls: ['./accordion-item.component.scss'],
  template: `
    <ng-content select="nb-accordion-item-header"></ng-content>
    <ng-content select="nb-accordion-item-body"></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NbAccordionItemComponent implements OnInit, OnChanges, OnDestroy {

  @Input('collapsed')
  @HostBinding('class.collapsed')
  get collapsed(): boolean {
    return this.collapsedValue;
  }
  set collapsed(val: boolean) {
    this.collapsedValue = convertToBoolProperty(val);
    this.collapsedChange.emit(this.collapsedValue);
    this.invalidate();
  }

  @Input('expanded')
  @HostBinding('class.expanded')
  get expanded(): boolean {
    return !this.collapsed;
  }
  set expanded(val: boolean) {
    this.collapsedValue = !convertToBoolProperty(val);
  }

  @Input('disabled')
  @HostBinding('class.disabled')
  get disabled(): boolean {
    return this.disabledValue;
  }
  set disabled(val: boolean) {
    this.disabledValue = convertToBoolProperty(val);
    this.invalidate();
  }

  @Output() collapsedChange = new EventEmitter<boolean>();

  accordionItemInvalidate = new Subject<boolean>();

  private collapsedValue = true;
  private disabledValue = false;
  private alive = true;

  constructor(@Host() private accordion: NbAccordionComponent, private cd: ChangeDetectorRef) {
  }


  toggle() {
    if (!this.disabled) {
      const willSet = !this.collapsed;

      if (!this.accordion.multi) {
        this.accordion.openCloseItems.next(true);
      }
      this.collapsed = willSet;
    }
  }

  open() {
    !this.disabled && (this.collapsed = false);
  }

  close() {
    !this.disabled && (this.collapsed = true);
  }

  ngOnInit() {
    this.accordion.openCloseItems
      .pipe(takeWhile(() => this.alive))
      .subscribe(collapsed => {
        !this.disabled && (this.collapsed = collapsed);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.accordionItemInvalidate.next(true);
  }

  ngOnDestroy() {
    this.alive = false;
    this.accordionItemInvalidate.complete();
  }

  private invalidate() {
    this.accordionItemInvalidate.next(true);
    this.cd.markForCheck();
  }
}
